import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { injectPageScripts } from "../utils/loadScripts.js";
import { setupBaseMetaData } from "../utils/metaData.js";
import { setTabSelected } from "../redux/data/dataSlice.js";
import { getCTBadges, getChallenges, getGames, getRewardSections } from '../redux/data/dataActions';
import LoadingGif from "../assets/images/loading-gif-2.gif";
import OverviewColumnSection from "./overview/overviewColumnSection.jsx";
import OverviewSwimlane from "./overview/overviewSwimlane.jsx";

import "../assets/css/overview.css";
import "../assets/css/badges.css";

function Overview() {
    const dispatch = useDispatch();
    const [refreshSections, setRefreshSections] = useState(true);
    const badgeSections = useSelector(state => state.data.ctBadgeSections);
    const rewardSections = useSelector(state => state.data.rewardSections);
    const gamesSections = useSelector(state => state.data.gamesSections);
    const challengeData = useSelector(state => state.data.challengeData);
    const tabSelected = useSelector(state => state.data.tabSelected);
    const memberSince = useSelector(state => state.data.memberSince);
    const userType = useSelector(state => state.data.userType);

    const votingSwimlaneSectionID = "6,0b";
    const benefitSection = rewardSections ? rewardSections["0a"] ? rewardSections["0a"] : null : null;
    const overviewBadges = badgeSections ? badgeSections["0c"] ? badgeSections["0c"] : null : null;
    const membersOnly = rewardSections ? rewardSections["0d"] ? rewardSections["0d"] : null : null;
    const stayLockedIn = rewardSections ? rewardSections["0e"] ? rewardSections["0e"] : null : null;

    const votingTitle = "Make Some Noise";
    const votingSubtitle = "Vote to make your voice heard among the crowd.";
    const overviewVotes = {
        title: votingTitle,
        subtitle: votingSubtitle,
        rewards: gamesSections && gamesSections.rewards && gamesSections.rewards.length > 0 ? gamesSections.rewards.filter(reward =>
            (reward.extra_data.section_id && reward.extra_data.section_id.toLowerCase() === votingSwimlaneSectionID) ||
            (reward.extra_data.reward_section && reward.extra_data.reward_section.toLowerCase() === votingSwimlaneSectionID)
        ) : [],
    };

    useEffect(() => {
        if (refreshSections) {
            // refreshing sections
            console.log("refreshing sections");
            dispatch(getCTBadges("overview"));
            dispatch(getGames());
            dispatch(getChallenges());
            dispatch(getRewardSections("overview"));
            setRefreshSections(false);
        }
    }, [dispatch, refreshSections]);

    useEffect(() => {
        // analytics variable
        window.digitalData.page.pageInfo.pageName = "nba:membership-hub:overview";
        window.digitalData.page.pageInfo.siteSection = "nba:membership-hub";
        window.digitalData.page.content = { categoryTitle: "Overview", categoryType: "membership-hub" };
        window.digitalData.site = { propertyName: "nba:web", league: "nba" };
        if (window.digitalData.user) {
            window.digitalData.user.userState = "authenticated";
            window.digitalData.user.userType = userType;
        }

        console.log("Overview: analytics added");

        injectPageScripts();
        setupBaseMetaData();
    }, []);

    useEffect(() => {
        console.log("Overview: useEffect[dispatch]");
        console.log("tabSelected: overview");
        
        if (!memberSince || !badgeSections || badgeSections.length === 0) {
            dispatch(getCTBadges("overview"));
        }
        if (!rewardSections || rewardSections.length === 0) {
            dispatch(getRewardSections("overview"));
        }
        if (!gamesSections || gamesSections.length === 0) {
            dispatch(getGames());
        }
        if (!challengeData) {
            dispatch(getChallenges());
        }
        if (tabSelected !== "overview") {
            setTabSelected("overview");
        }
    }, [dispatch, tabSelected]);

    return (
        <div id="overview-page-container">
            { benefitSection && benefitSection.rewards && benefitSection.rewards.length > 0 &&
                <OverviewSwimlane section={benefitSection} type="benefit" more="benefits" /> }
            { overviewVotes && overviewVotes.rewards && overviewVotes.rewards.length > 0 &&
                <OverviewSwimlane title={votingTitle} subtitle={votingSubtitle} section={overviewVotes} type="voting" more="voting" /> }
            { overviewBadges && overviewBadges.badges && overviewBadges.badges.length > 0 &&
                <OverviewSwimlane section={overviewBadges} type="badge" more="badges" /> }
            { membersOnly && membersOnly.rewards && membersOnly.rewards.length > 0 &&
                <OverviewColumnSection two-col={true} section={membersOnly} type="column" /> }
            { stayLockedIn && stayLockedIn.rewards && stayLockedIn.rewards.length > 0 &&
                <OverviewColumnSection section={stayLockedIn} type="column" /> }

            {!benefitSection && !gamesSections && !overviewBadges && !membersOnly &&
                <div className="loading-gif" style={{ alignSelf: "center" }}>
                    <img src={LoadingGif} alt="" />
                </div>
            }
        </div>
    );
}

export default Overview;
